export const COMPONENT_HEIGHT = 50;
export const changeCalanderType = [
  {
    name: {
      fa: 'شمسی به میلادی و قمری',
      en: 'Shamsi To Miladi and Hijri',
      ru: 'Shamsi To Miladi and Hijri',
      ja: 'Shamsi To Miladi and Hijri',
      it: 'Shamsi To Miladi and Hijri',
      de: 'Shamsi To Miladi and Hijri',
      ar: 'الشمسية إلى الميلادية والقمرية',
    },
    type: 'shamsi',
  },
  {
    name: {
      fa: 'میلادی به شمسی و قمری',
      en: 'Miladi To Shamsi and Hejri',
      ru: 'Miladi To Shamsi and Hejri',
      ja: 'Miladi To Shamsi and Hejri',
      it: 'Miladi To Shamsi and Hejri',
      de: 'Miladi To Shamsi and Hejri',
      ar: 'الميلادية إلى الشمسي والقمري',
    },
    type: 'miladi',
  },
  {
    name: {
      fa: 'قمری به شمسی و میلادی',
      en: 'Hijri To Shamsi and Miladi',
      ru: 'Hijri To Shamsi and Miladi',
      ja: 'Hijri To Shamsi and Miladi',
      it: 'Hijri To Shamsi and Miladi',
      de: 'Hijri To Shamsi and Miladi',
      ar: 'القمري إلى الشمسي و الميلادية',
    },
    type: 'hijri',
  },
];

export const calculateDayType = [
  {
    name: {
      fa: 'محاسبه تعداد روز',
      en: 'Calculate the Number of Days',
      ru: 'Calculate the Number of Days',
      ja: 'Calculate the Number of Days',
      it: 'Calculate the Number of Days',
      de: 'Calculate the Number of Days',
      ar: 'احسب عدد الأيام',
    },
    type: 'days',
  },
  {
    name: {
      fa: 'محاسبه تاریخ برگشت',
      en: 'Calculation of Return Date',
      ru: 'Calculation of Return Date',
      ja: 'Calculation of Return Date',
      it: 'Calculation of Return Date',
      de: 'Calculation of Return Date',
      ar: 'حساب تاريخ العودة',
    },
    type: 'return',
  },
  {
    name: {
      fa: 'محاسبه تاریخ رفت',
      en: 'Calculate the Date of Departure',
      ru: 'Calculate the Date of Departure',
      ja: 'Calculate the Date of Departure',
      it: 'Calculate the Date of Departure',
      de: 'Calculate the Date of Departure',
      ar: 'احسب تاريخ المغادرة',
    },
    type: 'departure',
  },
];

export const PATH_CHOICES = [
  {
    id: 'ALL',
    name: {
      fa: 'تمامی مسیر ها',
      en: 'All Routes',
      de: 'All Routes',
      ar: 'All Routes',
      ja: 'All Routes',
      it: 'All Routes',
      ru: 'All Routes',
    },
  },
  {
    id: 'ORIGIN-DES',
    name: {
      fa: 'مبدا و مقصد',
      en: 'Origin & Destination',
      de: 'Origin & Destination',
      ar: 'Origin & Destination',
      ja: 'Origin & Destination',
      it: 'Origin & Destination',
      ru: 'Origin & Destination',
    },
  },
  {
    id: 'SITI',
    name: {
      fa: 'سیتی',
      en: 'Siti',
      de: 'Siti',
      ar: 'Siti',
      ja: 'Siti',
      it: 'Siti',
      ru: 'Siti',
    },
  },
  {
    id: 'SITO',
    name: {
      fa: 'سیتو',
      en: 'Sito',
      de: 'Sito',
      ar: 'Sito',
      ja: 'Sito',
      it: 'Sito',
      ru: 'Sito',
    },
  },
  {
    id: 'SOTI',
    name: {
      fa: 'سوتی',
      en: 'Soti',
      de: 'Soti',
      ar: 'Soti',
      ja: 'Soti',
      it: 'Soti',
      ru: 'Soti',
    },
  },
  {
    id: 'SOTO',
    name: {
      fa: 'سوتو',
      en: 'Soto',
      de: 'Soto',
      ar: 'Soto',
      ja: 'Soto',
      it: 'Soto',
      ru: 'Soto',
    },
  },
];
export const WEEK_DAYS = [
  {
    id: 1,
    name: {
      fa: 'شنبه',
      en: 'Saturday',
      ru: 'Суббота',
      it: 'Sabato',
      ar: 'السبت',
      ja: '土曜日',
      de: 'Samstag',
    },
  },
  {
    id: 2,
    name: {
      fa: 'یکشنبه',
      en: 'Sunday',
      ru: 'Воскресенье',
      it: 'Domenica',
      ar: 'الأحد',
      ja: '日曜日',
      de: 'Sonntag',
    },
  },
  {
    id: 3,
    name: {
      fa: 'دوشنبه',
      en: 'Monday',
      ru: 'Понедельник',
      it: 'Lunedì',
      ar: 'الاثنين',
      ja: '月曜日',
      de: 'Montag',
    },
  },
  {
    id: 4,
    name: {
      fa: 'سه شنبه',
      en: 'Tuesday',
      ru: 'Вторник',
      it: 'Martedì',
      ar: 'الثلاثاء',
      ja: '火曜日',
      de: 'Dienstag',
    },
  },
  {
    id: 5,
    name: {
      fa: 'چهارشنبه',
      en: 'Thursday',
      ru: 'Четверг',
      it: 'Giovedì',
      ar: 'الخميس',
      ja: '木曜日',
      de: 'Donnerstag',
    },
  },
  {
    id: 6,
    name: {
      fa: 'پنجشنبه',
      en: 'Wednesday',
      ru: 'Среда',
      it: 'Mercoledì',
      ar: 'الأربعاء',
      ja: '水曜日',
      de: 'Mittwoch',
    },
  },
  {
    id: 7,
    name: {
      fa: 'جمعه',
      en: 'Friday',
      ru: 'Пятница',
      it: 'Venerdì',
      ar: 'الجمعة',
      ja: '金曜日',
      de: 'Freitag',
    },
  },
];
